
export const classifyList = [
    { title: 'classify.hardwareFittings', imgUrl: require('/public/img/classify/1.jpg'), count: 200 },
    { title: 'classify.hardwareTools', imgUrl: require('/public/img/classify/2.jpg'), count: 200 },
    { title: 'classify.autoProducts', imgUrl: require('/public/img/classify/3.jpg'), count: 200 },
    { title: 'classify.bicycleProducts', imgUrl: require('/public/img/classify/4.jpg'), count: 200 },
    { title: 'classify.sportsGoods', imgUrl: require('/public/img/classify/5.jpg'), count: 200 },
    { title: 'classify.kitchenGoods', imgUrl: require('/public/img/classify/6.jpg'), count: 200 },
    { title: 'classify.bathroomProducts', imgUrl: require('/public/img/classify/7.jpg'), count: 200 },
    { title: 'classify.dailyGoods', imgUrl: require('/public/img/classify/8.jpg'), count: 200 },
    { title: 'classify.homeProducts', imgUrl: require('/public/img/classify/9.jpg'), count: 200 },
    { title: 'classify.summerProducts', imgUrl: require('/public/img/classify/10.jpg'), count: 200 },
    { title: 'classify.winterProducts', imgUrl: require('/public/img/classify/11.jpg'), count: 200 },
    { title: 'classify.christmasProducts', imgUrl: require('/public/img/classify/12.jpg'), count: 200 }
]